import { UpdatePasswordModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/identity-service-lib/src/wrapper/inputs/users/update-password.model';

import { Logger } from '@app/core/logger/logger';

import { useCpmsBoUpdatePasswordMutation } from 'src/core/service/cpms-bo-user-me.service';

type UpdatePasswordHookReturn = {
  isLoading: boolean;
  isError: boolean;
  onSubmit: (payload: Omit<UpdatePasswordModel, 'id'>) => void;
};

type UpdatePasswordHookProps = {
  onSuccess?: () => void;
};

export function useUpdatePassword(
  props: UpdatePasswordHookProps,
): UpdatePasswordHookReturn {
  const { onSuccess = () => {} } = props;
  const [updatePassword, { isLoading, isError }] =
    useCpmsBoUpdatePasswordMutation();

  const onSubmit = (payload: Omit<UpdatePasswordModel, 'id'>): void => {
    updatePassword(payload).then((result) => {
      if (!('error' in result)) {
        onSuccess();
      } else {
        Logger.error('Failed to update password', result.error);
      }
    });
  };

  return {
    onSubmit,
    isLoading,
    isError,
  };
}
